import { ApiStatusCodeEntity } from '@packages/shared/core/common/entities/Api';

export function isSuccessfulStatusCode(statusCode: ApiStatusCodeEntity) {
  return statusCode >= 200 && statusCode < 300;
}
